import { useState, useEffect } from 'react';
import { useMediaQuery, FormControl, Select, MenuItem, Paper, Stack, Typography } from '@mui/material';
import { formatCurrency } from '../../../common/Helper';

const MonthPicker = (props) => {
	const { dividends } = props;

	const [monthlyEarnings, setMonthlyEarnings] = useState([])
	const [currentMonth, setCurrentMonth] 		= useState(new Date().getMonth() + 1)

	const isSmallScreen = useMediaQuery(theme => theme.breakpoints.down('md'))
	
	const monthNames = ['','Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro']

	useEffect(() => {
		var dividendsByMonth = []

		for (let i=1;i<monthNames.length;i++) {
			dividendsByMonth.push({
				name 		: monthNames[i],
				earnings 	: formatCurrency(dividends?.filter(d => d.month === i).reduce((acc, d) => acc + parseFloat(d.earnings), 0), 'SMALL')
			})
		}

		dividendsByMonth.push({
			name 		: 'Total',
			earnings 	: formatCurrency(dividends?.reduce((acc, d) => acc + parseFloat(d.earnings), 0), 'SMALL')
		})	

		setMonthlyEarnings(dividendsByMonth)
	}, [])

	const handleChange = (index) => {
		setCurrentMonth(index);

		if (props.onChange) props.onChange(index)
	}

	return (
		isSmallScreen ? (
			<FormControl sx={{width: 'calc(100% - 32px)'}}>
				<Select
					value={currentMonth}
					onChange={(e) => handleChange(e.target.value)}
					>{
					monthlyEarnings.map((month, index) => (
					<MenuItem key={index+1} 
						value={index+1}
						>
						{month.name} - {month.earnings ? month.earnings : '0'}
					</MenuItem>
				))}
				</Select>
			</FormControl>
		) : (
			<Stack spacing={2} direction={"column"} width={'100%'} alignItems="center">{
				monthlyEarnings.map((month, index) => (
					<Paper key={index+1} 
						sx={{
							bgcolor : (index+1 === currentMonth ? "rgb(25, 118, 210, 0.80)" : "white"),
							height: 50,
							width: '100%',
							justifyContent : 'center',
							cursor : 'pointer'
						}}
						onClick={() => handleChange(index+1)}
						>
						<Stack alignItems="center" gap={0}>
							<Typography>{month.name}</Typography>
							<Typography sx={{justifyContent : 'center'}}>{month.earnings ? month.earnings : '0'}</Typography>
						</Stack>
					</Paper>
				))}
			</Stack>
		)
	)
}

export default MonthPicker;